/** Recuperado del despliegue 2026-10-05. Conserva lógica y memoización originales. */
import {
  rec_BuscarConversacion as BuscarConversacion,
  rec_JSXRuntime as JSXRuntime,
  rec_React as React,
  rec_ReactCompiler as ReactCompiler,
} from "../../runtime/index.jsx";
export function Componente_r3_114_51(e) {
  let t = (0, ReactCompiler.c)(13),
    {
      valor: n,
      opciones: r,
      placeholder: i,
      extra: a,
      onElegir: o,
      onCancelar: s,
    } = e,
    c = a === void 0 ? null : a,
    l = (0, React.useRef)(null),
    u,
    f;
  (t[0] === Symbol.for(`react.memo_cache_sentinel`)
    ? ((u = () => {
        l.current?.querySelector(`input`)?.focus();
      }),
      (f = []),
      (t[0] = u),
      (t[1] = f))
    : ((u = t[0]), (f = t[1])),
    (0, React.useEffect)(u, f));
  let p;
  t[2] === s
    ? (p = t[3])
    : ((p = (e) => {
        (e.stopPropagation(), e.key === `Escape` && s());
      }),
      (t[2] = s),
      (t[3] = p));
  let m;
  t[4] !== c || t[5] !== o || t[6] !== r || t[7] !== i || t[8] !== n
    ? ((m = (
        <BuscarConversacion
          value={n}
          onChange={o}
          opciones={r}
          placeholder={i}
          extra={c}
        />
      )),
      (t[4] = c),
      (t[5] = o),
      (t[6] = r),
      (t[7] = i),
      (t[8] = n),
      (t[9] = m))
    : (m = t[9]);
  let h;
  return (
    t[10] !== p || t[11] !== m
      ? ((h = <div ref={l} className={`w-full`} onKeyDown={p} children={m} />),
        (t[10] = p),
        (t[11] = m),
        (t[12] = h))
      : (h = t[12]),
    h
  );
}
